<div class="header" [class.light-scheme]="colorScheme === ColorScheme.LIGHT">
  <ng-container *ngIf="hasArrowBack; else defaultView">
    <div class="title-with-arrow-back">
      <app-pencil-button (clickEvent)="handleArrowBackClick()">
        <app-pencil-icon type="mat-icon" name="keyboard_arrow_left"></app-pencil-icon>
      </app-pencil-button>
      <p>{{ title }}</p>
    </div>
  </ng-container>
  <ng-template #defaultView>
    <p>{{ title }}</p>
  </ng-template>

  <app-pencil-button (clickEvent)="handleClose()">
    <app-pencil-icon type="mat-icon" name="close"></app-pencil-icon>
  </app-pencil-button>
</div>
<div class="body" [class.light-scheme]="colorScheme === ColorScheme.LIGHT">
  <ng-content></ng-content>
</div>
